import { useState, useEffect, useRef } from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useTheme, useMediaQuery } from '@mui/material';
import { useUpdateUserPassMutation } from '../../state/api';
import { workshops } from '../helper/workshopsData';

function WorkshopSlider({lockedWP}) {
  console.log(lockedWP);
  
  const [lockedWorkshop, setLockedWorkshop] = useState(lockedWP ? lockedWP : null); // For locked workshop
  const [selectedWorkshop, setSelectedWorkshop] = useState(null); // For current selection
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [updateUserPass] = useUpdateUserPassMutation();
  const swiperRef = useRef(null);

  // Get user data from session storage
  const userData = JSON.parse(sessionStorage.getItem('userData'));

  useEffect(() => {
    setLockedWorkshop(userData.workshop);
    if (userData && userData.workshop) {
      setLockedWorkshop(userData.workshop); // Set locked workshop from userData
      
      // Find index of the locked workshop to center it
      /* const lockedWorkshopIndex = workshops.findIndex(workshop => workshop.id === userData.workshop);
      if (swiperRef.current && lockedWorkshopIndex >= 0) {
        swiperRef.current.slideTo(lockedWorkshopIndex, 0); // Center the locked workshop
      } */
    }

   
  }, [userData , lockedWP]);

  const handleWorkshopSelect = (workshopId) => {
    setSelectedWorkshop(workshopId); // Set the clicked workshop as selected
    console.log(`Selected Workshop ID: ${workshopId}`);
  };

  const handleConfirmWorkshop = async () => {
    if (!selectedWorkshop) return;
    setLoading(true);

    try {
      const res = await updateUserPass({
        userId: userData.userId,
        passType: userData.passType,
        workshop: selectedWorkshop,
      });


      if (res.data) {
        sessionStorage.setItem('userData', JSON.stringify({
          ...userData,
          workshop: selectedWorkshop,
        }));
        setLockedWorkshop(selectedWorkshop); // Update locked workshop
      }
    } catch (error) {
      console.error("Error updating workshop:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{
        position: 'relative',
        overflow: 'hidden',
        width: isMobile ? '250px' : '80%',
        maxWidth: '1000px',
        margin: '0 auto',
        paddingTop: isMobile ? '1em' : '2em',
      }}>
        {/* Left fade effect */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '50px',
          height: '100%',
          background: 'linear-gradient(to right, rgba(0, 0, 0, 0.3), transparent)',
          pointerEvents: 'none',
          zIndex: 2,
        }} />

        {/* Right fade effect */}
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '50px',
          height: '100%',
          background: 'linear-gradient(to left, rgba(0, 0, 0, 0.3), transparent)',
          pointerEvents: 'none',
          zIndex: 2,
        }} />

        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          spaceBetween={5}
          slidesPerView={isMobile ? 1.1 : 2.5}
          centeredSlides={true}
          loop={true}
          style={{
            paddingBottom: '20px',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          {workshops.map((workshop) => (
            <SwiperSlide key={workshop.id}>
              <div
                onClick={() => handleWorkshopSelect(workshop.id)}
                style={{
                  position: 'relative',
                  width: isMobile ? "90%" : "250px",
                  height: isMobile ? "180px" : "200px",
                  cursor: 'pointer',
                  color: "white",
                  background: `url(${workshop.background})`,
                  backgroundSize: "cover",
                  padding: '20px',
                  border:
                    lockedWP == workshop.id
                      ? '4px solid #ff4500' // Different color for locked workshop
                      : selectedWorkshop === workshop.id
                      ? '4px solid #00e5ff' // Color for currently selected workshop
                      : '4px solid #fff', // Default color
                  borderRadius: '10px',
                  transition: 'transform 0.3s ease',
                  backgroundColor: selectedWorkshop === workshop.id ? '#f0f8ff' : '#ffffff',
                  boxShadow: selectedWorkshop === workshop.id ? '0 4px 15px rgba(0, 229, 255, 0.4)' : '0 4px 15px rgba(0, 0, 0, 0.1)',
                  overflow: 'hidden',
                }}
              >
                {/* Gradient overlay */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '40%',
                  background: 'linear-gradient(to top, rgba(0, 0, 0, 1), transparent)',
                }}></div>

                {/* Title positioned at the bottom */}
                <h3 style={{
                  position: 'absolute',
                  bottom: '10px',
                  left: '20px',
                  margin: 0,
                  color: 'white',
                  zIndex: 2,
                }}>{workshop.title}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <Typography variant="body1" sx={{ mb: 3, fontSize: "12px", color: '#969191' }}>
        * Défilez les différents workshops en swipant, puis choisissez-en un en cliquant dessus et validez.
      </Typography>

      {lockedWorkshop ? (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Typography sx={{ color: 'green', mt: 2 }}>
            You have chosen to attend this workshop: {workshops.find((w) => w.id ==  lockedWP ? lockedWP : null)?.title}.
          </Typography>
          <Typography sx={{ color: 'gray', mt: 1 }}>
            You can still change your selection.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmWorkshop}
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Confirm Workshop"}
          </Button>
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Typography sx={{ color: 'red', mt: 2 }}>
            You must select a workshop to attend.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmWorkshop}
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Confirm Workshop"}
          </Button>
        </div>
      )}
    </div>
  );
}

export default WorkshopSlider;
